import { useQuery } from '@tanstack/react-query';

import { fetchAPI } from '../utils/api';

export const useOrderStatus = (
  orderId: number,
  visible: boolean,
  defaultData?: { operation: any[]; payment: any[]; loading: boolean }
) => {
  const orderStatus = useQuery<{
    operation: any[];
    payment: any[];
    loading: boolean;
  }>(
    ['order-status-tracking', orderId, visible],
    async () => {
      if (!!defaultData?.operation?.length || !!defaultData?.payment?.length) {
        return defaultData;
      }

      if (!visible) {
        return { operation: [], payment: [], loading: false };
      }

      const resp = await fetchAPI(`order/${orderId}/status-tracking`);

      return {
        operation: resp?.status_tracking?.order_status || [],
        payment: resp?.status_tracking?.payment_status || [],
        loading: false,
      };
    },
    {
      staleTime: 5 * 60 * 1000,
      placeholderData: { operation: [], payment: [], loading: true },
    }
  );

  return orderStatus;
};

export const useOrderShippingStatus = (
  orderId: number,
  visible: boolean,
  defaultData?: []
) => {
  const orderStatus = useQuery<{
    tracking: any[];
    loading: boolean;
  }>(
    ['order-shipping-status-tracking', orderId, visible],
    async () => {
      if (!!defaultData?.length) {
        return { tracking: defaultData, loading: false };
      }

      if (!visible) {
        return { tracking: [], loading: false };
      }

      const resp = await fetchAPI(`order/${orderId}/shipping-status-tracking`);

      return {
        tracking: resp?.shipping_status_tracking || [],
        loading: false,
      };
    },
    {
      staleTime: 5 * 60 * 1000,
      placeholderData: { tracking: [], loading: true },
    }
  );

  return orderStatus;
};

export const useOrderIsAutoPayment = (
  orderId: number,
  visible: boolean,
  defaultData?: boolean
) => {
  const orderStatus = useQuery<{
    isAuto: boolean;
    loading: boolean;
  }>(
    ['order-is-auto-payment', orderId, visible],
    async () => {
      if (defaultData !== undefined) {
        return { isAuto: defaultData, loading: false };
      }

      if (!visible) {
        return { isAuto: false, loading: false };
      }

      const resp = await fetchAPI(`order/${orderId}/is-auto-payment`);

      return {
        isAuto: !!resp?.is_auto_payment,
        loading: false,
      };
    },
    {
      staleTime: 5 * 60 * 1000,
      placeholderData: { isAuto: false, loading: true },
    }
  );

  return orderStatus;
};
